import request from '@/utils/request'

export function fetchCity(query) {
  return request({
    url: 'https://search.heweather.net/find',
    method: 'get',
    params: query
  })
}